import './GameGrid.css';

function GameGrid({ m, n, children }) {
  return (
    <div className='game-grid-border'>
      <div className='game-grid' style={{ gridTemplateRows: `repeat(${m}, 50px)`, gridTemplateColumns: `repeat(${n}, 50px)` }}>
        {children}
      </div>
    </div>
  );
}

export default GameGrid;